
import { defineComponent, PropType } from '@vue/composition-api';
import { MyBetsFilters } from '../../../../../types/sport';
import IllinoisSelect from '../Select.vue';
import IllinoisDatePicker from '../DatePicker.vue';

interface FilterOption {
  text: string;
  value: string;
}

export default defineComponent({
  name: 'BetFilters',
  components: {
    IllinoisSelect,
    IllinoisDatePicker
  },
  props: {
    filters: {
      type: Object as PropType<MyBetsFilters>,
      required: true
    },
    showBetCode: {
      type: Boolean,
      default: false
    },
    showOnlyMyBetsToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localFilters: Object.assign({}, this.filters) as MyBetsFilters
    };
  },
  computed: {
    contextOptions(): FilterOption[] {
      return [
        { text: this.capitalize(this.t('generic.all')), value: '' },
        { text: this.capitalize(this.t('bets.prematch')), value: 'prematch' },
        { text: this.capitalize(this.t('bets.live')), value: 'live' },
        { text: this.capitalize(this.t('bets.mixed')), value: 'mixed' },
        { text: this.capitalize(this.t('bets.antepost')), value: 'antepost' }
      ];
    },
    typeOptions(): FilterOption[] {
      return [
        { text: this.capitalize(this.t('generic.all')), value: '' },
        { text: this.capitalize(this.t('bets.single')), value: 'single' },
        { text: this.capitalize(this.t('bets.multiple')), value: 'multiple' },
        { text: this.capitalize(this.t('bets.integral')), value: 'integral' },
        { text: this.capitalize(this.t('bets.system')), value: 'system' }
      ];
    },
    resultOptions(): FilterOption[] {
      return [
        { text: this.capitalize(this.t('generic.all')), value: '' },
        { text: this.capitalize(this.t('bets.pending')), value: 'pending' },
        { text: this.capitalize(this.t('bets.win')), value: 'win' },
        { text: this.capitalize(this.t('bets.lose')), value: 'lose' },
        { text: this.capitalize(this.t('bets.void')), value: 'void' },
        { text: this.capitalize(this.t('bets.cancelled')), value: 'cancelled' }
      ];
    },
    payedOptions(): FilterOption[] {
      return [
        { text: this.capitalize(this.t('generic.all')), value: '' },
        { text: this.capitalize(this.t('generic.yes')), value: 'yes' },
        { text: this.capitalize(this.t('generic.no')), value: 'no' }
      ];
    }
  },
  watch: {
    filters: {
      handler(newFilters: MyBetsFilters) {
        this.localFilters = { ...newFilters };
      },
      deep: true
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    capitalize(str: string): string {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    handleSearch(): void {
      this.$emit('search', { ...this.localFilters });
    },
    handleReset(): void {
      const now = new Date();
      const oneMonthAgo = new Date(now.setMonth(now.getMonth() - 1));

      this.localFilters = {
        type: '',
        result: '',
        payed: '',
        code: '',
        betCode: '',
        bet_context: '',
        fromTime: oneMonthAgo.toISOString().substr(0, 10),
        toTime: new Date().toISOString().substr(0, 10),
        onlyPlayedByMe: true
      };

      this.$emit('reset', { ...this.localFilters });
    }
  }
});
